export default __webpack_public_path__ + "623d59376ac08e19e94312e064d14055.svg";